export const windowStyles = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: '6px',
};
